import React from 'react';
import { Box, Typography, IconButton } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';

const DetailsCard = ({
  title,
  details = [], // [{ label: 'Name', value: 'John Doe' }]
  isDeletable = false,
  onDelete = () => {},
}) => {
  return (
    <Box
      sx={{
        display: 'flex',
        background: '#fff',
        borderRadius: 2,
        p: 2,
        gap: 2,
        flexDirection: 'column',
      }}
    >
      {/* Header */}
      <Box sx={{ display: 'flex', justifyContent: 'space-between', gap: 1 }}>
        <Typography variant="h2">{title}</Typography>
        {isDeletable && (
          <IconButton
            size="small"
            onClick={onDelete}
            sx={{ color: '#995A00' }}
          >
            <DeleteIcon fontSize="small" />
          </IconButton>
        )}
      </Box>

      {/* Details List */}
      <Box sx={{ display: 'flex', flexDirection: 'column' }}>
        {details.map((item, index) => (
          <Box
            key={index}
            sx={{ display: 'flex', py: 1, justifyContent: 'space-between' }}
          >
            <Typography variant="labelD" sx={{ color: '#666' }}>
              {item.label}
            </Typography>
            <Typography variant="body1">{item.value || '-'}</Typography>
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default DetailsCard;
